import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { Breadcrumb, BreadcrumbsService } from './breadcrumbs.typings';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BreadcrumbsComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  public items: Observable<Breadcrumb[]>;
  @HostBinding('class.wai-breadcrumbs') public className = true;
  private limit$ = new BehaviorSubject<number>(0);

  @Input()
  get limitTo(): number {
    return this.limit$.value;
  }

  set limitTo(value: number) {
    const normalized = Number.isFinite(value) ? value : 0;
    this.limit$.next(normalized);
  }

  constructor(private breadcrumbsService: BreadcrumbsService) {
    this.items = combineLatest([this.breadcrumbsService.items, this.limit$]).pipe(
      map(([items, limit]) => (limit > 0 ? items?.slice(0, limit) : items)),
    );
  }
}
